export default __webpack_public_path__ + "static/media/icon-jek-white.1de5e121.svg";